import type {KeyTextField} from '@prismicio/client'
import type {Top10AiToolsSliceDefaultPrimaryFaqsItem} from 'prismicio-types'
import React, {useCallback, useState} from 'react'

interface Props {
  eyebrow: KeyTextField
  title: KeyTextField
  faqs: Top10AiToolsSliceDefaultPrimaryFaqsItem[]
}

const FaqSection: React.FC<Props> = ({eyebrow, title, faqs}) => {
  const [openIndex, setOpenIndex] = useState(0)

  const toggle = useCallback((i: number) => {
    setOpenIndex((prev) => (prev === i ? -1 : i))
  }, [])

  return (
    <section style={{scrollMarginTop: 64}}>
      <div className="t10-wrap-narrow">
        {eyebrow && <p className="t10-eyebrow">{eyebrow}</p>}
        {title && (
          <h2 className="t10-section-title" style={{marginBottom: 48}}>
            {title}
          </h2>
        )}
        {faqs && faqs.length > 0 && (
          <div className="t10-faq-list">
            {faqs.map((f, i) => (
              <div key={i} className="t10-faq-item">
                <button
                  className="t10-faq-btn"
                  onClick={() => toggle(i)}
                  aria-expanded={openIndex === i}
                  aria-controls={`faq-answer-${i}`}
                >
                  <span className="t10-faq-q">{f.q}</span>
                  <span className="t10-faq-mark">{openIndex === i ? '−' : '+'}</span>
                </button>
                {openIndex === i && (
                  <p id={`faq-answer-${i}`} className="t10-faq-a">
                    {f.a}
                  </p>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  )
}

export default FaqSection
